var map = {
	"./messages.en.xlf": [
		"./node_modules/raw-loader/index.js!./src/i18n/messages.en.xlf",
		"messages.en.xlf"
	],
	"./messages.fr.xlf": [
		"./node_modules/raw-loader/index.js!./src/i18n/messages.fr.xlf",
		"messages.fr.xlf"
	],
	"./messages.nl.xlf": [
		"./node_modules/raw-loader/index.js!./src/i18n/messages.nl.xlf",
		"messages.nl.xlf"
	],
	"./messages.pl.xlf": [
		"./node_modules/raw-loader/index.js!./src/i18n/messages.pl.xlf",
		"messages.pl.xlf"
	],
	"./messages.tr.xlf": [
		"./node_modules/raw-loader/index.js!./src/i18n/messages.tr.xlf",
		"messages.tr.xlf"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/i18n lazy recursive ./node_modules/raw-loader/index.js!./ ^\\.\\/messages\\..*\\.xlf$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ./node_modules/raw-loader ^\.\/messages\..*\.xlf$
// module id = ./src/i18n lazy recursive ./node_modules/raw-loader/index.js!./ ^\.\/messages\..*\.xlf$
// module chunks = main